import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { EmpresasDataGrid } from '../../organisms';
import { PageTemplate } from '../';

const EmpresasTemplate = memo(props => {
  const { initialState, state, ...restDataGridProps } = props.dataGridProps;

  return (
    <PageTemplate title={props.title} subtitle={props.subtitle} scrollable={false}>
      <EmpresasDataGrid
        {...restDataGridProps}
        initialState={{
          ...initialState
        }}
        state={state}
      />
    </PageTemplate>
  );
});

EmpresasTemplate.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
  readData: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default EmpresasTemplate;
